// extracted by mini-css-extract-plugin
export var numpadContainer = "_lo-1";
export var phoneButton = "_lo-0";